const columns = [
  {
    headerLabel: 'linearConference.report.dtInclusion',
    type: 'date',
    field: 'dtInclusion',
    align: 'left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'linearConference.report.hrInclusion',
    type: 'general',
    field: 'hrInclusion',
    align: 'left',
    render: true,
    fixed: true,
    customWidth: 70,
  },
  {
    headerLabel: 'linearConference.report.branch',
    type: 'general',
    field: 'branch',
    align: 'left',
    customWidth: 120,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'linearConference.report.cdLm',
    type: 'general',
    field: 'cdLm',
    align: 'left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'linearConference.report.dsProduct',
    type: 'general',
    field: 'dsProduct',
    align: 'left',
    customWidth: 160,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'linearConference.report.section',
    type: 'general',
    field: 'section',
    align: 'left',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'linearConference.report.subsection',
    type: 'general',
    field: 'subsection',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.subtype',
    type: 'general',
    field: 'subtype',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.productSituation',
    type: 'general',
    field: 'productSituation',
    align: 'left',
    render: true,
    fixed: false,
    customWidth: 80,
  },
  {
    headerLabel: 'linearConference.report.c50',
    type: 'decimal',
    field: 'c50',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.c10',
    type: 'decimal',
    field: 'c10',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.inResolved',
    type: 'index-alt',
    field: 'inResolved',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.inCapture',
    type: 'general',
    field: 'inCapture',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.inNotFound',
    type: 'general',
    field: 'inNotFound',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.inExcluded',
    type: 'general',
    field: 'inExcluded',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.sellPriceStock',
    type: 'general',
    field: 'sellPriceStock',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.reason',
    type: 'general',
    field: 'description',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.tsStart',
    type: 'general',
    field: 'tsStart',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.tsTreatment',
    type: 'general',
    field: 'tsTreatment',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.tsEnd',
    type: 'general',
    field: 'tsEnd',
    align: 'left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.cdLdap',
    type: 'general',
    field: 'cdLdap',
    align: 'left',
    render: true,
    fixed: false,
  },
]

export default columns
